module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a9f68e6391e803ca55d49bdbb536a946.png";